module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAzMSAyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMS44IiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0uMTI2IDkuOTg1aDI4LjY3OU0yMC42MDMuOTYxbDguNTg3IDkuMDQtOC41ODcgOS4wMzUiLz48L2c+PC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/forward-arrow-light.svg
// module id = FK9t
// module chunks = 1